<template>
  <div class="main-div">
    <div class="contact-container">
      <h1>{{ $t('text.contact_us') }}</h1>
      
      <h4>{{ $t('text.contact_us_text') }}</h4>
      
      <b-icon class="top-margin" icon="at" font-scale="4"></b-icon>
      
      <a href="mailto:hjortronvagen15@gmail.com">
        <h4 v-if="isSmallScreen">hjortronvagen15@gmail.com</h4>
        <h3 v-if="!isSmallScreen">hjortronvagen15@gmail.com</h3>
      </a>

      <img v-if="isSmallScreen" class="top-margin small-image" src="../../assets/icons/undraw_online_posts.svg" />
      <img v-if="!isSmallScreen" class="top-margin large-image" src="../../assets/icons/undraw_online_posts.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactComponent",
  data() {
    return {
      windowWidth : window.innerWidth
    };
  },
  computed: {
    isSmallScreen() {
      return this.windowWidth < 600;
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-div {
  background-color: #4a6163;
  color: #ddd;
  position: relative;
  min-height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;
  text-align: center;
}

.contact-container {
  position: relative;
  padding-right:30px;
  padding-left:30px;
  top: 30%;
}

.info-container {
  margin-top: 50px;
}

.top-margin {
  margin-top: 50px;
}

.large-image {
  height: 300px;
}

.small-image {
  height: 200px;
}

a {
  color: #ddd;
}

h1 {
  font-size: 50px;
}

</style>
